import styled, { css } from 'styled-components';

export type TaxesLabelVariant = 'inline' | 'block';

/* Positioning context for the absolutely-rendered TaxesIncludedTooltip
   so its caret can sit above the info icon at the right edge of the
   taxes label. */
export const TaxesAnchor = styled.div`
  position: relative;
  display: inline-flex;
  flex-direction: column;
  align-items: flex-end;
  max-width: 100%;
`;

export const TaxesLabel = styled.div<{ $variant?: TaxesLabelVariant; $dotted?: boolean }>`
  ${({ theme, $variant = 'inline' }) =>
    $variant === 'block' ? theme.kallisto.mixins.font('Caption') : theme.kallisto.mixins.font('BodySmall')};
  cursor: pointer;

  ${({ $variant = 'inline' }) =>
    $variant === 'block'
      ? css`
          display: block;
          text-align: right;

          @media (max-width: 767px) {
            text-align: left;
          }
        `
      : css`
          display: flex;
          align-items: center;

          @media (max-width: 767px) {
            justify-content: flex-end;
          }
        `}

  ${({ $dotted, $variant = 'inline' }) =>
    $dotted &&
    $variant !== 'block' &&
    css`
      /* Target only leaf text spans so each text run draws exactly one
         underline without baseline overlap. AddElementToLastWordInString
         wraps the last word in an inline-flex atomic box, so a small gap
         remains around the space between words — accepted trade-off vs.
         the doubled-dot rendering seen when decorating wrapper elements. */
      span:not(:has(span)) {
        text-decoration: underline;
        text-decoration-style: dotted;
        text-decoration-thickness: 2px;
        text-underline-offset: 2px;
      }
    `}

  img {
    filter: invert(55%) sepia(6%) saturate(247%) hue-rotate(201deg) brightness(99%) contrast(90%);
    margin-left: 2px;
    width: 14px;
    height: 14px;
  }
`;
